import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Consts } from "../../pages/consts";
import {getInputFocusStyle} from "../../pages/utils";

const TimeIntake = ({ index, intake, onSetIntake }) => {
  const { t } = useTranslation();
  const [intakeTime, setIntakeTime] = useState(intake?.intakeTime || "");
  const [dosage, setDosage] = useState(intake?.dosage || "");
  const [isDosageFieldFocused, setIsDosageFieldFocused] = useState(false);

  const isCompleted = !isNaN(intake?.dosage) && intake?.dosage > 0 && intake?.intakeTime;

  const handleChangeDosage = (e) => {
    setDosage(e.target.value);
    onSetIntake({...intake, dosage: e.target.value}, index);
  }

  const handleChangeIntakeTime = (e) => {
    setIntakeTime(e.target.value);
    onSetIntake({...intake, intakeTime: e.target.value}, index);
  }

  return (
    <article className="time-intake-card">
      <header className="time-intake-card__header">
        <span className={`time-intake-card__title ${isCompleted ? "time-intake-card__title--completed" : ""}`}>
          {t("intake")} {index + 1}
        </span>
      </header>

      <div className="time-intake-card__field">
        <label className="time-intake-card__label">{t("dosage")}*</label>
        <div className="time-intake-card__input-group">
          <input
            value={dosage}
            type={Consts.NUMBER}
            min="0"
            onFocus={() => setIsDosageFieldFocused(true)}
            onBlur={() => setIsDosageFieldFocused(false)}
            onChange={(e) => handleChangeDosage(e)}
            className="form-input time-intake-card__input"
            style={getInputFocusStyle(isDosageFieldFocused)}
          />
          <span className="time-intake-card__unit">{t(intake?.dosageUnit?.dosageUnit)}</span>
        </div>
      </div>

      <div className="time-intake-card__field">
        <label className="time-intake-card__label">{t("time")}*:</label>
        <input
          value={intakeTime}
          type={Consts.TIME}
          className="form-input time-intake-card__input time-intake-card__input--time"
          onChange={(e) => handleChangeIntakeTime(e)}
        />
      </div>
    </article>
  );
};

export default TimeIntake;
